/**
 * Columns — a two-column layout wrapper for chapter body blocks (CX-2728
 * "Designed to Last": Compatible Finishing Processes | Design for Disassembly).
 *
 * Pure layout: it takes already-rendered `left` / `right` content so it stays
 * decoupled from the block renderer in ChapterSubPage (no circular import).
 * Stacks to a single column on mobile.
 */

import type { ReactNode } from "react";
import "./Columns.css";

interface ColumnsProps {
  left: ReactNode;
  right: ReactNode;
}

export const Columns = ({ left, right }: ColumnsProps) => (
  <div className="cmf-columns">
    <div className="cmf-columns__col">{left}</div>
    <div className="cmf-columns__col">{right}</div>
  </div>
);
